module.exports = __webpack_public_path__ + "static/media/bg-sobre-defa-desktop.494572ac.png";